<template>
    <!-- Generato da claude — Abbonamenti redesign Proposta A -->
    <div>
        <div class="card" v-if="socio.abbonamenti && socio.abbonamenti.length > 0">
            <div class="card-header card-header-background">
                <span class="dk-header-title">🎟️ I miei abbonamenti</span>
                <span class="dk-header-badge" v-if="nValidi > 0">{{nValidi}} validi</span>
            </div>
            <div class="card-body p-0">
                <div class="dk-list-item"
                    v-for="abbonamento in socio.abbonamenti"
                    :key="abbonamento.ID_ABBONAMENTO">
                    <div class="dk-list-icon"
                        :style="abbonamento.VALIDITA_DURATA == 1 && abbonamento.VALIDITA_INGRESSI == 1
                            ? 'background:#e6f9f0'
                            : 'background:#fde8e8'">
                        {{ abbonamento.VALIDITA_DURATA == 1 && abbonamento.VALIDITA_INGRESSI == 1 ? '✅' : '⛔' }}
                    </div>
                    <div class="dk-list-info">
                        <div class="dk-list-title">{{abbonamento.DESCRIZIONE}}</div>
                        <div class="dk-list-sub">
                            Scadenza: {{filters.formatDate(abbonamento.DATA_SCADENZA)}}
                            &nbsp;·&nbsp; Ingressi: {{abbonamento.TOT}}
                        </div>
                    </div>
                    <div class="dk-list-action">
                        <span class="badge" :class="getBadgeClass(abbonamento)">
                            {{getDescrizioneStato(abbonamento)}}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="card" v-else>
            <div class="card-header card-header-background">
                <span class="dk-header-title">🎟️ I miei abbonamenti</span>
            </div>
            <div class="card-body p-0">
                <div class="dk-empty-state">
                    <span class="dk-empty-state-icon">🎟️</span>
                    Nessun abbonamento registrato
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Abbonamenti',
    data: function() {
        return {
            filters: global.filters,
            socio: {},
        }
    },
    computed: {
        nValidi() {
            if (!this.socio.abbonamenti) return 0;
            return this.socio.abbonamenti.filter(a => a.VALIDITA_DURATA == 1 && a.VALIDITA_INGRESSI == 1).length;
        },
    },
    methods: {
        getDescrizioneStato(abbonamento) {
            if (abbonamento.VALIDITA_DURATA == 1 && abbonamento.VALIDITA_INGRESSI == 1) return 'Valido';
            if (abbonamento.VALIDITA_DURATA == 0) return 'Scaduto';
            return 'Esaurito';
        },
        getBadgeClass(abbonamento) {
            if (abbonamento.VALIDITA_DURATA == 1 && abbonamento.VALIDITA_INGRESSI == 1) return 'badge-success';
            if (abbonamento.VALIDITA_DURATA == 0) return 'badge-danger';
            return 'badge-warning';
        },
    },
    created() {
        utils.ajax('/deskalo/socio', {}, (response) => {
            this.socio = response.data;
        });
    },
}
</script>
